import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ram",
  "use": "ram-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"ram\"><path d=\"m7.5 8.5 2 2 1-1-2-2zM5 11l2 2 1-1-2-2zm5-5 2 2 1-1-2-2zm7 1-6-6L1 11l6 6 1-1 1 1 8-8-1-1zm-2.12 2L9 14.88l-1-1-1 1L3.12 11 11 3.12 14.88 7l-1 1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol